import { useEffect } from "react";
import { useViewStateWrapper } from "../../../store/store";
import { ANALYTICS_GRID_KEY_PREFIX } from "../../../utils/helpers/analyticsGridKey";

// Module-level so a StrictMode unmount/remount (same report) can cancel its own clear.
let pending: { report: string; timer: ReturnType<typeof setTimeout> } | null =
  null;

// Saved table/drill-down views live only while the user is in the report; leaving it
// for anywhere except an incident clears them.
export const useClearReportViewOnLeave = (report: string) => {
  useEffect(() => {
    if (pending?.report === report) {
      clearTimeout(pending.timer);
      pending = null;
    }
    // Arrived (fresh or back from an incident): any earlier incident click is consumed.
    useViewStateWrapper.getState().setLeavingForIncident(false);

    return () => {
      const viewState = useViewStateWrapper.getState();
      if (viewState.leavingForIncident) return;
      pending = {
        report,
        timer: setTimeout(() => {
          pending = null;
          const state = useViewStateWrapper.getState();
          state.clearGridViewsWithPrefix(ANALYTICS_GRID_KEY_PREFIX);
          state.setDrilldown(null);
        }, 0),
      };
    };
  }, [report]);
};
